import React, { useRef, useEffect } from 'react'

const TeamSection = () => {
  const team = [
    { 
      name: "Nathan", 
      role: "Líder", 
      desc: "Apaixonado por conectar jovens através da fé e da música", 
      img: "/pessoas/nathan.jpeg"
    },
    { 
      name: "Debora", 
      role: "Líder", 
      desc: "Dedicada a criar experiências significativas e transformadoras", 
      img: "/pessoas/debora.jpeg"
    },
    { 
      name: "Matheus", 
      role: "Líder", 
      desc: "Comprometido em inspirar e equipar a próxima geração", 
      img: "/pessoas/matheus.png"
    },
    { 
      name: "Jordana", 
      role: "Líder", 
      desc: "Focada em construir comunidade e fortalecer relacionamentos", 
      img: "/pessoas/Jordana.jpeg" 
    }
  ]

  const TeamCard = ({ member }) => {
    const cardRef = useRef(null)
    const containerRef = useRef(null)

    useEffect(() => {
      const el = cardRef.current
      const container = containerRef.current
      
      const handleMove = (e) => {
        const { left, top, width, height } = container.getBoundingClientRect()
        const x = (e.clientX - left) / width - 0.5
        const y = (e.clientY - top) / height - 0.5
        el.style.transform = `perspective(1000px) rotateY(${x * 25}deg) rotateX(${y * -25}deg)`
      }

      const handleLeave = () => {
        el.style.transform = `perspective(1000px) rotateY(0deg) rotateX(0deg)`
      }

      container.addEventListener('mousemove', handleMove)
      container.addEventListener('mouseleave', handleLeave)
      return () => {
        container.removeEventListener('mousemove', handleMove)
        container.removeEventListener('mouseleave', handleLeave)
      }
    }, [])

    return (
      <div ref={containerRef} className="group relative py-10 flex justify-center items-center">
        <div 
          ref={cardRef}
          className="relative w-80 h-[480px] bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] transition-all duration-300 ease-out p-6"
          style={{ transformStyle: 'preserve-3d' }}
        >
          <div className="absolute inset-4 border border-gray-100 rounded-[2rem] pointer-events-none" style={{ transform: 'translateZ(20px)' }} />

          <div 
            className="relative h-64 w-full rounded-3xl overflow-hidden shadow-2xl mb-6 transform-gpu transition-transform duration-500 group-hover:scale-105"
            style={{ transform: 'translateZ(60px)' }}
          >
            <img 
              src={member.img} 
              alt={member.name} 
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" 
            />
            <div className="absolute inset-0 bg-gradient-to-t from-orange-500/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>

          {/* TEXTOS AUMENTADOS NO HOVER */}
          <div className="text-center space-y-2 transition-all duration-500" style={{ transform: 'translateZ(40px)' }}>
            <h4 className="text-3xl font-black text-gray-900 tracking-tighter uppercase leading-none group-hover:scale-110 transition-transform duration-500">
              {member.name}
            </h4>
            
            <div className="inline-block px-4 py-1.5 bg-orange-500/10 rounded-full transition-colors group-hover:bg-orange-500/20">
              <p className="text-orange-600 font-black text-sm uppercase tracking-[0.25em]">
                {member.role}
              </p>
            </div>
            
            {/* DESCRIÇÃO: Maior, mais grossa e com melhor contraste */}
            <p className="pt-4 text-gray-600 text-sm md:text-base leading-relaxed font-bold opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0 px-2">
              {member.desc}
            </p>
          </div>

          <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-4/5 h-4 bg-black/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
    )
  }

  return (
    <section id="equipe" className="relative py-32 bg-[#fdfdfd] overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden opacity-50">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-orange-100/40 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-rose-100/40 blur-[120px] rounded-full" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-24">
          <span className="text-orange-500 font-black text-sm tracking-[0.5em] uppercase border-b-2 border-orange-500/20 pb-2">
            Liderança Ativa
          </span>
          <h2 className="text-6xl md:text-7xl font-black text-gray-900 tracking-tighter mt-6 leading-none">
            NOSSA <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-rose-600">EQUIPE</span>
          </h2>
          <p className="text-gray-500 mt-8 max-w-2xl mx-auto font-bold text-lg leading-relaxed">
            Conheça as mentes e corações que dedicam seu tempo para unificar propósitos e transformar realidades.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((member, idx) => (
            <TeamCard key={idx} member={member} />
          ))}
        </div>
      </div>

      <style jsx>{`
        section {
          perspective: 2000px;
        }
      `}</style>
    </section>
  )
}

export default TeamSection